import { Toaster } from "@repo/ui/components/Sonner";
import { ConfirmDialogProvider } from "@repo/ui/providers/ConfirmDialogProvider";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { queryClient, trpc, trpcClient } from "./lib/trpc";
import { ThemeProvider } from "./providers/ThemeProvider.tsx";

import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <ConfirmDialogProvider>
            <App />
            <Toaster />
          </ConfirmDialogProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </trpc.Provider>
  </StrictMode>,
);
